import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useState } from 'react'

import styles from '../SidebarControls.module.scss'
import { ReactComponent as GearIcon } from './gear.svg'

const MessagingSettings = ({ filterTimeTresholdInDays, setFilterTimeTresholdInDays }) => {
  const [open, setOpen] = useState()

  const [currentTreshold, setCurrentTreshold] = useState(filterTimeTresholdInDays)

  function handleSave() {
    setFilterTimeTresholdInDays(Number(currentTreshold))
    setOpen(false)
  }

  function handleCancel() {
    setOpen(false)
    setCurrentTreshold(filterTimeTresholdInDays)
  }

  return (
    <>
      <button className={styles.sortButton} onClick={() => setOpen(true)}>
        <GearIcon fill="#0079ff" />
      </button>
      {open && (
        <ConfirmationDialog
          title="Messaging settings"
          positiveMessage="Save changes"
          negativeMessage="Cancel"
          onClose={handleCancel}
          onReject={handleCancel}
          onConfirm={handleSave}
        >
          <p>Hide messages older than</p>
          <div className={styles.inputHolder}>
            <TextInput
              style={{ width: 80, marginTop: 5, marginRight: 10 }}
              type="number"
              value={currentTreshold}
              onChange={e => setCurrentTreshold(e.target.value)}
            />
            days
          </div>
        </ConfirmationDialog>
      )}
    </>
  )
}

export default MessagingSettings
